<template>
  <div class="l-wrapper">
    <div class="l-item">
      <div class="t-serial t-sans"><p>{{single.serial}}</p></div>
      <img :src='single.image'>
      <h1 class="t-serif">{{single.title}}</h1>
      <div class="author"><h2 class="t-sans">{{single.author}}</h2></div>
      <p class="t-serif t-project">{{single.description}}</p>
      <template v-if="single.trackList">
        <div class="track-list">
          <table>
            <tr v-for="track in single.trackList" :key="track.id">
              <template v-if="playable(track)">
                <td class="play-track" @click="nextSong(track.title, track.trackUrl, track.author)">{{track.title}}</td>
                <td class="track-author">{{track.author}}</td>
              </template>
              <template v-else>
                <td class="no-play-track">{{track.title}}</td>
                <td class="track-author">{{track.author}}</td>
              </template>
            </tr>
          </table>
        </div>
      </template>
      <template v-if="single.available">
        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" :value="single.ppUrl">
          <input type="submit" :value="single.stockMessage + '  |  £' + single.price" class="m-btn-buy t-sans">
        </form>
      </template>
      <template v-else>
        <div class="m-btn-buy m-btn-out t-sans"><span>{{single.stockMessage}}</span></div>
      </template>
    </div>
    <div class="l-images">
      <img v-for="image in single.images" :key="image.id" :src="image.url">
    </div>
    <router-link :to="{ name: 'Shop' }"><div class="m-btn-back"><span></span></div></router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ShopSingle',
  computed: {
    ...mapGetters(['getShopItembySerial']),
    single () {
      let x = this.$route.params.single
      return this.getShopItembySerial(x)
    }
  },
  methods: {
    ...mapActions(['updatePlayer']),
    nextSong (title, url, author) {
      this.updatePlayer([title, url, author])
    },
    playable (payload) {
      if (payload.trackUrl !== '') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped lang='scss'>

.l-wrapper {
  display: flex;
  height: calc(100vh - 75px);
  overflow-y: hidden;
  width: 100vw;
}

.l-item {
    display: inline-block;
    position: relative;
    max-width: 500px;
    overflow-y: scroll;
    height: 100%;
}

.l-images {
  display: inline-block;
  overflow-y: scroll;
  height: 100%;
  width: 100%;

  img {
    width: 100%;
  }
}

h1 {
  text-transform: uppercase;
  font-weight: normal;
}

.author {
  text-align: center;
  h2 {
    display: inline;
    background: #fff;
    border: 1px solid #000;
    color: #000;
    border-radius: 20px;
    padding: 8px 12px;
    font-size: 90%;
  }
}

.t-project {
  padding-top: 20px;
}

.t-serial {
  text-align: center;
  font-size: 1.2rem;
  position: sticky;
  top: 18px;
  p {
    opacity: 0.9;
    background: rgba(74, 255, 100, 0.9);
    color: #000;
    font-size: 0.75rem;
    display: inline;
    border-radius: 20px;
    padding: 5px 10px;
    box-shadow: 0px 0px 10px #f2f2f2;
  }
}

form {
  position: sticky;
  bottom: 0px;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 50%);
  height: 50px;
}

.m-btn-out {
  cursor: not-allowed !important;
  &:hover {
    background: #f2f2f2 !important;
  }
}

.m-btn-back {
  top: 20px;
  left: 20px;
  width: 20px;
  height: 20px;
  position: fixed;
  background: rgba(74, 255, 100, 0.9);
  transition: background 0.4s;
  box-shadow: 0px 0px 10px #f2f2f2;
  border-radius: 40px;
  cursor: pointer;
  span {
    width: 0;
    height: 0;
    position: absolute;
    transition: background 0.4s;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 7px solid #000;
    transform: translate(5.5px, 5px);
  }
  &:hover {
    background: rgba(0,0,0,0.9);
    span {
      border-right-color: #fff;
    }
  }
}

.m-btn-buy {
  color: #fff;
  cursor: pointer;
  border-radius: 20px;
  border: 1px solid #fff;
  background: rgba(0,0,0,0.9);
  position: sticky;
  // font-family: arial, sans-serif;
  bottom: 20px;
  padding: 8px 15px;
  display: table;
  margin: 0 auto;
  font-size: 0.8rem;
  transition: background 0.3s, color 0.3s;

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #000;
    }
  }

  span {
    margin: 0px 5px 0px 2px;
  }

  &:hover {
    color: #000;
    background: #4aff64;
  }
}
@media all and (max-width: 600px) {
  .l-item {
    max-width: none;
    border-bottom: 1px solid #000;
    overflow: inherit;
    height: auto;
  }

  form {
    height: 80px;
  }

  .l-wrapper {
    display: block;
    width: 100%;
    overflow: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ShopSingle.vue